// extracted by mini-css-extract-plugin
export default {"button":"SettingBtn_button__U2+ER"};